import React, { PropsWithChildren, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from '../components/errorBoundary/errorBoundary';
import { useAsync } from '../hooks/useAsync';
import { AppClient, ClientConfigResponse } from '../services/partnerCenterService';

import { RootContainer } from './src/containers/RootContainer';
import { ClientApplication } from './src/msal/clientApp';
import { settings } from './src/settings/settings';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import '../../src/components/spinner/spinner.scss';
import '../assets/style/devExtreme/devExtreme.scss';
import '../assets/style/devExtreme/devExtremeGlobalOverrides.scss';
import appInsights from '../common/applicationInsights';
import Loading from '../components/loading/loading';
import '../index.scss';
const root = createRoot(document.getElementById('app')!);

const AppSettings: React.FC<PropsWithChildren> = ({ children }) => {
    const { executeAsync, isLoading, error, data } = useAsync<ClientConfigResponse>();

    useEffect(() => {

        executeAsync(async () => {
            const client = new AppClient();
            client.isAnonymous = true;

            return client.getClientConfig();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (isLoading) {
        return <div className="spinner">
            <Loading />
        </div>
    }

    if (error) {
        return <div>{error.message}</div>
    }

    if (data) {
        settings.setSettings(data);
        appInsights.initialize(data.appInsightsConnectionString);
    }

    return <>{children}</>
}

const MsalInitialize: React.FC<PropsWithChildren> = ({ children }) => {
    const { executeAsync, isLoading, error } = useAsync();

    useEffect(() => {
        executeAsync(ClientApplication.initialize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <div className="spinner">
            <Loading />
        </div>
    }

    if (error) {
        return <div>{error.message}</div>
    }

    return <>{children}</>
}

root.render(
    <ErrorBoundary>
        <AppSettings>
            <MsalInitialize>
                <RootContainer />
            </MsalInitialize>
        </AppSettings>
    </ErrorBoundary>
)
